<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Verificação de Movimentação de Estoque
        </p>
      </div>
    </div>

    <div class="col-12 q-my-xl">
      <q-tabs
        v-model="tab"
        dense
        active-color="black"
        no-caps
        active-bg-color="brand-11"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab
          style="background-color: #d9d9d9; border-radius: 4px"
          name="verificacaoEstoque"
          label="Verificação Estoque vs Estoque Localizado"
          no-caps
        />
        <q-tab
          style="background-color: #d9d9d9; border-radius: 4px"
          name="verificacaoMovimentacao"
          label="Verificação Movimentação vs Estoque"
          no-caps
        />
      </q-tabs>

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="verificacaoEstoque">
          <TabelaVerificaoEstoqueLocalizado />
        </q-tab-panel>
      </q-tab-panels>

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="verificacaoMovimentacao">
          <TabelaVerificacaoEstoque />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </q-page>
</template>

<script setup>
import { ref } from "vue";

import TabelaVerificaoEstoqueLocalizado from "../components/TabelaVerificaoEstoqueLocalizado.vue";
import TabelaVerificacaoEstoque from "../components/TabelaVerificacaoEstoque.vue";

const tab = ref("verificacaoEstoque");
</script>

<style scoped></style>
